import * as React from 'react'
import * as st from './giftCardModal.module.scss'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import * as Types from 'DVWebNodeWpsRuntime'
import GiftCardBalance = Types.atv.wps.GiftCardBalance

interface BalancesTableProps {
  balances: GiftCardBalance[]
}

export const BalancesTable = ({ balances }: BalancesTableProps) => {
  if (!balances || !balances.length) {
    return null
  }

  return (
    <table className={st.balancesTable}>
      <tbody>
      <tr>
        <th><TextLocalizer stringID={StringId.DV_DP_GC_balance_type_heading}/></th>
        <th><TextLocalizer stringID={StringId.DV_DP_GC_balance_amount_heading}/></th>
      </tr>
      {balances && balances.map((balance) => (
        <tr key={balance.label.string}>
          <td>{balance.label.string}</td>
          <td>{balance.displayAmount}</td>
        </tr>
      ))}
      </tbody>
    </table>
  )
}